import { render } from "./ReservationsComponent.vue?vue&type=template&id=7fa76270"
import script from "./ReservationsComponent.vue?vue&type=script&lang=js"
export * from "./ReservationsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__